import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import styles from './ConfirmationModal.module.css';

const ConfirmationModal = ({ onConfirm, onCancel, type }) => {
  const { t } = useTranslation();

  let message = '';
  if (type === 'delete') {
    message = t('deleteConfirmation');
  } else if (type === 'save') { 
    message = t('saveConfirmation');
  } else if (type === 'delete-account') {
    message = t('deleteAccountConfirmation');
  }

  return (
    <motion.div
      className={styles.modalOverlay}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <motion.div
        className={styles.modalContent}
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.9, opacity: 0 }}
        transition={{ duration: 0.2 }}
      >
        <p>{message}</p>
        <div className={styles.buttonContainer}>
          <button onClick={onConfirm} className={styles.confirmButton}>
            {t('confirmButtonYes')}
          </button>
          <button onClick={onCancel} className={styles.cancelButton}>
            {t('confirmButtonNo')}
          </button>
        </div>
      </motion.div>
    </motion.div>
  );
};

export default ConfirmationModal;
